import { useState } from 'react';
import CurrencyInput from '@/components/base/CurrencyInput';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  employeeName: string;
  employeeId: string;
}

const PAYMENT_TYPES = ['Maaş', 'Avans', 'Prim', 'Mesai', 'Kesinti', 'Diğer'];
const PAYMENT_METHODS = ['Nakit', 'Banka Havalesi', 'EFT', 'Diğer'];

export default function EmployeePaymentModal({ isOpen, onClose, onSave, employeeName }: Props) {
  const [form, setForm] = useState({
    payment_type: 'Maaş',
    amount: 0,
    payment_date: new Date().toISOString().split('T')[0],
    payment_method: 'Nakit',
    description: '',
  });

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (form.amount <= 0) return;
    onSave(form);
    setForm({ payment_type: 'Maaş', amount: 0, payment_date: new Date().toISOString().split('T')[0], payment_method: 'Nakit', description: '' });
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose}></div>
      <div className="relative bg-background-50 rounded-2xl w-full max-w-md max-h-[90vh] overflow-hidden shadow-xl flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-background-200/70">
          <h3 className="text-lg font-semibold text-foreground-900">Ödeme / Avans Kaydı</h3>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-background-100 cursor-pointer">
            <i className="ri-close-line text-lg text-foreground-500"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <p className="text-sm text-foreground-500">Personel: <span className="font-medium text-foreground-800">{employeeName}</span></p>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1.5">Ödeme Türü</label>
            <select value={form.payment_type} onChange={e => setForm(prev => ({ ...prev, payment_type: e.target.value }))} className="input-base w-full">
              {PAYMENT_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1.5">Tutar <span className="text-red-400">*</span></label>
            <CurrencyInput value={form.amount} onChange={v => setForm(prev => ({ ...prev, amount: v }))} placeholder="Tutar" className="w-full" />
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1.5">Ödeme Tarihi</label>
            <input type="date" value={form.payment_date} onChange={e => setForm(prev => ({ ...prev, payment_date: e.target.value }))} className="input-base w-full" />
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1.5">Ödeme Yöntemi</label>
            <select value={form.payment_method} onChange={e => setForm(prev => ({ ...prev, payment_method: e.target.value }))} className="input-base w-full">
              {PAYMENT_METHODS.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1.5">Açıklama</label>
            <textarea value={form.description} onChange={e => setForm(prev => ({ ...prev, description: e.target.value }))} className="input-base w-full min-h-[70px]" placeholder="Açıklama..." rows={2}></textarea>
          </div>
        </form>

        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-background-200/70">
          <button type="button" onClick={onClose} className="btn-secondary cursor-pointer whitespace-nowrap">İptal</button>
          <button type="button" onClick={handleSubmit} className="btn-primary cursor-pointer whitespace-nowrap">Kaydet</button>
        </div>
      </div>
    </div>
  );
}